var _module_exports = "<div class=\"danger-text\" ng-show=\"display\">\n  {{message}}\n</div>";;
var path = 'views/directives/render_error.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;